var $339abb56a5e63f4f$exports = {};
$339abb56a5e63f4f$exports = {
    "invalidSelection": (args, formatter)=>`Se\xe7ilen ${formatter.plural(args.selectedCount, {
            one: `tarih`,
            other: `tarihler`
        })} m\xfcsait de\u{11F}il.`
};


export {$339abb56a5e63f4f$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
